<mat-form-field>
    <mat-label>Filter</mat-label>
    <input [formControl]="formControl" matInput placeholder="Name" autocomplete="off">
</mat-form-field>
<div class="table-container mat-elevation-z2">
    <div class="loading-shade"
         *ngIf="isLoadingResults || error">
        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
        <div class="error" *ngIf="error">
            An error has occurred, please try again later.
        </div>
    </div>

    <mat-table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>#</mat-header-cell>
            <mat-cell *matCellDef="let element" data-label="Id"> {{element.id}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
            <mat-cell *matCellDef="let element" data-label="Title">
                {{element.title}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="author">
            <mat-header-cell *matHeaderCellDef>Author</mat-header-cell>
            <mat-cell *matCellDef="let element" data-label="Author"> {{element.author.name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="contents">
            <mat-header-cell *matHeaderCellDef>Contents</mat-header-cell>
            <mat-cell *matCellDef="let element" data-label="Contents"> {{element.contents.length}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="comments">
            <mat-header-cell *matHeaderCellDef>Comments</mat-header-cell>
            <mat-cell *matCellDef="let element" data-label="Comments"> {{element.comments.length}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="created_at">
            <mat-header-cell *matHeaderCellDef>Created at</mat-header-cell>
            <mat-cell
                *matCellDef="let element" data-label="Created at"> {{(element.created_at ? (element.created_at | date) : (119731017 | date))}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nsfw">
            <mat-header-cell *matHeaderCellDef class="centered">NSFW</mat-header-cell>
            <mat-cell *matCellDef="let element" class="centered" data-label="NSFW">
                <div [ngClass]="{'active': (element.nsfw === 1)}" class="status"
                     [matTooltip]="(element.nsfw === 1 ? 'Enabled':'Disabled')"></div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToIdc(row)"></mat-row>
    </mat-table>

    <mat-paginator [length]="length" [pageSize]="limit"></mat-paginator>
</div>
